import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const router = new VueRouter({
    routes: [
        { path: '/', component: () => import('@/views/index.vue'), meta: { title: '优行关爱小助手', auth: true } }, // 首页
        { path: '/404', component: () => import('@/views/404.vue'), meta: { title: '404' } }, // 404
        { path: '/disclaimer', component: () => import('@/views/disclaimer.vue'), meta: { title: '免责声明' } }, // 免责声明
        { path: '/guidance', component: () => import('@/views/guidance.vue'), meta: { title: '未注册' } }, // 未注册引导
    ]
})

export default router
